import { computed } from 'mobx';
import moment from 'moment';
import { getDisplayDate, utc } from '../../../libs/date';

export default class TicketModel {
  id;
  store;

  dateFormat(date, format) {
    return moment.utc(date).format(format || 'YYYY-MM-DD');
  }

  constructor(store, ticket) {
    this.store = store;
    this.updateFromJson(ticket);
  }

  @computed get asJson() {
    return {
      id: +this.id,
      generated_date: this.generated_date,
      user_id: this.user_id,
      status_id: this.status_id,
      reason_id: this.reason_id,
      action_id: this.action_id,
      summary: this.summary,
      description: this.description,
      station_id: this.station_id,
      assigned_to: this.assigned_to,
      end_date: this.end_date,
      name: this.name,
      mobile_no: this.mobile_no,
      email_address: this.email_address,
      last_log: this.last_log || {},
      archived: this.archived
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.generated_date = json.generated_date;
    this.user_id = json.user_id;
    this.status_id = json.status_id;
    this.reason_id = json.reason_id;
    this.action_id = json.action_id;
    this.summary = json.summary;
    this.description = json.description;
    this.station_id = json.station_id;
    this.assigned_to = json.assigned_to;
    this.end_date = json.end_date;
    this.name = json.name;
    this.mobile_no = json.mobile_no;
    this.email_address = json.email_address;
    this.last_log = json.last_log || {};
    this.archived = json.archived;
    this.assigned_to_user = json.assigned_to_user;
    this.created_by_user = json.created_by_user;
  }

  @computed get open_duration() {
    const
      cur = new Date(),
      from = new Date(this.generated_date),
      to = !this.archived ? cur : new Date(this.end_date);
    return to < from ? cur - from : to - from;
  }
}



// WEBPACK FOOTER //
// ./src/models/Maintenance/Ticket/TicketModel.js